import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate, Link, NavLink, useParams, useLocation } from 'react-router-dom';

import { isMobile, isTablet } from 'react-device-detect';

//formik
import { Field, useFormik } from "formik";
import * as Yup from "yup";

//bootstrap
import Modal from 'react-bootstrap/Modal';

//services
import CategoryService from '../../../services/category'
import PlaceService from '../../../services/place'

//auth
import { useAuth } from '../../../context/AuthProvider'
import category from '../../../services/category';
//validation form
const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required("*Required")
        .min(5, "Must be at least 5 characters")
        .max(45, "Cannot exceed 45 characters"),
    description: Yup.string()
        .required("*Required")
        .min(10, "Must be at least 10 characters")
        .max(300, "Cannot exceed 45 characters"),
    place: Yup.string()
        .required("*Required")
});


function EditCategory() {
    const logo = require('../../../assets/img/logo/logo.png');

    const [imageDefault, setImageDefault] = useState('');

    //get id
    const { id } = useParams();

    //validation auth
    const auth = useAuth();

    //message error
    const [message, setMessage] = useState(null);
    //alert
    const [showAlert, setShowAlert] = useState(true);

    const [photo, setPhoto] = useState(null);

    const [imageCategory, setimageCategory] = useState('');

    //place get
    const [selectedPlaceName, setSelectedPlaceName] = useState('');
    const [placeCategoryId, setPlaceCategoryId] = useState('');


    //places
    const [placeGet, setPlaceGet] = useState('');

    const location = useLocation();
    //back
    const navigate = useNavigate();
    function goBack() {
        navigate(-1);
    }

    //modal
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        onLoadcategory();
        onLoadPlace();
    }
    const handleShow = () => setShow(true);

    useEffect(() => {
        onLoadcategory();
        onLoadPlace();
    }, []);

    //get first load Category id
    const onLoadcategory = async () => {
        try {
            let bearer_Token = {
                'headers': {

                    'Authorization': `Bearer ${auth.authToken()}`
                }
            };
            const getCatregoryId = await CategoryService.getByIdCategory(id, bearer_Token);
            formik.setValues({
                name: getCatregoryId.data.data.catName ? getCatregoryId.data.data.catName : '',
                description: getCatregoryId.data.data.catDescription ? getCatregoryId.data.data.catDescription : '',
                place: getCatregoryId.data.data.plaId ? getCatregoryId.data.data.plaId : '',
                active: getCatregoryId.data.data.catActive === '1',
            });
            setImageDefault(getCatregoryId.data.data.catImage);
            setSelectedPlaceName(getCatregoryId.data.data.plaName);
            setPlaceCategoryId(getCatregoryId.data.data.plaId);
        } catch (error) {

        }
    }
    const onLoadPlace = async () => {
        try {
            let bearer_Token = {
                'headers': {

                    'Authorization': `Bearer ${auth.authToken()}`
                }
            };
            const getAllPlace = await PlaceService.getAllplace(bearer_Token);
            setPlaceGet(getAllPlace.data);
        } catch (error) {

        }
    }
    const handlePhotoSelect = (event) => {
        const file = event.target.files[0];
        let error = false;
        if (file && !/^(image\/jpeg|image\/png)$/.test(file.type)) {
            document.getElementById('item_image').value = '';
            setPhoto('');
            error = true;
            setMessage({ error: true, msg: 'The file must be of type PNG or JPG' });
            return;
        }

        const maxSize = 1 * 1024 * 1024; // 5 MB
        if (file && file.size > maxSize) {
            document.getElementById('item_image').value = '';
            setPhoto('');
            error = true;
            setMessage({ error: true, msg: `The file must be less than or equal to  ${maxSize / 1024 / 1024} MB` });
            return;
        }
        setPhoto(event.target.files[0]);

        if (error === false) {
            handleSubmitImage(file);
        }
    }

    const handleSubmitImage = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        if (file) {
            let bearer_Token = {
                'headers': {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${auth.authToken()}`
                }
            };
            try {
                const uploadImage = await CategoryService.saveImage(formData, bearer_Token);
                if (uploadImage.status === 200 && uploadImage.data.statusCode === 201) {
                    //resolve(uploadImage.data.imaUrl);
                    setimageCategory(uploadImage.data.imaUrl);
                } else {
                    document.getElementById('item_image').value = '';
                    setShowAlert(true);
                    setMessage({ error: true, msg: "An error has occurred! try again" });
                }
            } catch (error) {
                if (error.response.status === 401) {
                    auth.logout()
                } else {
                    setShowAlert(true);
                    setMessage({ error: true, msg: "An error has occurred! try again" });
                }
            }
        }
    };
    const handleSubmit = async (values) => {
        const data = {
            name: values.name,
            description: values.description,
            place: values.place,
            active: values.active,
            image: imageCategory ? imageCategory : imageDefault,
        };
        try {
            let bearer_Token = {
                'headers': {
                    'Authorization': `Bearer ${auth.authToken()}`
                }
            };
            const createBlog = await category.updateByIdCategory(id, data, bearer_Token);

            if (createBlog.status === 200 && createBlog.data.statusCode === 200) {
                console.log('200');
                //create blog
                setShow(true);
            } else if (createBlog.status === 200 && createBlog.data.statusCode === 404) {
                console.log('404');
                //error
                setShowAlert(true);
                setMessage({ error: true, msg: "please make changes to update" });
            } else if (createBlog.status === 200 && createBlog.data.output.statusCode === 401) {
                auth.logout()
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) {
                auth.logout()
            } else {
                setShowAlert(true);
                setMessage({ error: true, msg: "An error has occurred! try again" });
            }
        }
    }
    //formik
    const formik = useFormik({
        initialValues: { name: "", description: "", place: "", active: false, },
        validateOnBlur: true,
        onSubmit: (values) => {
            handleSubmit(values);
        },
        validationSchema: validationSchema,
    });

    return (
        <>
            <div className='container pd-4'>
                <h4 className="text-center">EDIT CATEGORY</h4>
                <div className='row'>
                
                    <div className='col-6'>
                        <div className="btn-group mb-3" role="group">
                            <Link onClick={goBack} type="button" className="btn btn-outline-secondary btn-sm"><i className="fa-solid fa-chevron-left"></i> Back</Link>
                        </div>
                    </div>
                    <div className='pd-4'>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="form-floating mb-3 col-md-12 col-lg-6">
                                <input type="text" className="form-control" placeholder="name@example.com"
                                    id="name" name='name'
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur} />
                                <label htmlFor="name">
                                    {formik.errors.name && formik.touched.name
                                        ? <div className="text-danger">Name {formik.errors.name}</div>
                                        : <div className="">Name </div>
                                    }
                                </label>
                            </div>
                            <div className="form-floating mb-3 col-md-12 col-lg-6">
                                <textarea type="text" className="form-control" placeholder="name@example.com"
                                    id="description" name='description'
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur} />
                                <label htmlFor="description">
                                    {formik.errors.description && formik.touched.description
                                        ? <div className="text-danger">Description {formik.errors.description}</div>
                                        : <div className="">Description </div>
                                    }
                                </label>
                            </div>
                            <div className="form-floating mb-3 col-md-12 col-lg-6">
                                <select
                                    className="form-select"
                                    id="place"
                                    name="place"
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        setSelectedPlaceName(e.target.options[e.target.selectedIndex].text); // Establecer el nombre del lugar seleccionado
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.place}
                                >
                                    <option value="">Open this select menu</option>
                                    {Array.isArray(placeGet) && placeGet.length > 0 ? (
                                        placeGet.map((item) => (
                                            <option key={item.plaId} value={item.plaId}>
                                                {item.plaName}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">No places available</option>
                                    )}
                                </select>
                                <label htmlFor="place">
                                    {formik.errors.place && formik.touched.place
                                        ? <div className="text-danger">Please, Select a place {formik.errors.place}</div>
                                        : <div className="">Please, Select a place </div>
                                    }
                                </label>
                            </div>
                            <div className="mb-3 col-md-12 col-lg-6">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch"
                                        id="active"
                                        name='active'
                                        checked={formik.values.active}
                                        onChange={formik.handleChange} />
                                    <label className="form-check-label" htmlFor="active">Active</label>
                                </div>
                            </div>
                            <div className="mb-3 col-md-12 col-lg-6">
                                <img src={imageCategory ? imageCategory : imageDefault} className='img-fluid w-50' />
                            </div>
                            <div className="mb-5 ">
                                <label htmlFor="formFile" className="form-label">Please Select Image</label>
                                <input id='item_image' onChange={handlePhotoSelect} name='item_image' className="form-control" type="file" />
                            </div>
                            <button disabled={!formik.isValid} type="submit" className="btn btn-save">Update Category <i className="fa-regular fa-floppy-disk"></i></button>
                        </form>
                    </div>
                </div>
            </div>
            <Modal show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered >
                <div className="modal-content content">
                    <div className="modal-body text-center">
                        <i className="fa-regular fa-circle-check text-success icon-check"></i>
                        <p className='text-center'> Category has been update!.</p>
                    </div>
                    <div className="modal-footer footer-login-modal  d-md-block  text-center">
                        <button onClick={handleClose} className="btn btn-sm btn-send ">Close <i className="fa-solid fa-xmark"></i></button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export { EditCategory }